import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { tag } from 'postcss-selector-parser';
import classNames from 'classnames';
import CustomDropdownPracticeTags from '../../components/Inputs/CustomDropdownPracticeTags';

const inContestTag = {
  id: 0,
  tag: 'Участвует в конкурсе',
  alias: 'in-contest'
};

export default class TagsMobile extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    onChangeTags: PropTypes.func.isRequired,
    selectedTags: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    isLoadingSelectedTags: PropTypes.bool
  };


  selectTags = (tags) => {
    this.props.onChangeTags(tags);

  }

  render() {
    const { tags, selectedTags, isLoadingSelectedTags } = this.props
    return (
      <CustomDropdownPracticeTags
        categories={[inContestTag, ...tags]}
        selectedCategories={selectedTags}
        onChange={this.selectTags}
        isLoadingSelectedTags={isLoadingSelectedTags}
        />
    );
  }
}
